import { apiSlice } from 'api/apiSlice'

export const emailRegistrationApi = apiSlice.injectEndpoints({
  endpoints: build => ({
    registerEmail: build.mutation({
      query: body => ({
        app: 'sneakers',
        data: body,
        method: 'POST',
        url: `/web-api/v1/email_registration/register`,
      }),
    }),
  }),
})

export const { useRegisterEmailMutation } = emailRegistrationApi
